import { render } from "./IngresosView.vue?vue&type=template&id=3e7e05c9"
import script from "./IngresosView.vue?vue&type=script&lang=js"
export * from "./IngresosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__